import { ACCESS_TOKEN_KEY } from '@/shared/constants'
import { parseCookies } from 'nookies'

export function useAuth() {
  const token = parseCookies()[ACCESS_TOKEN_KEY]

  return {
    token,
  }
}
